'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdKeyboardHide = function MdKeyboardHide(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 38.4l-6.6-6.8h13.2z m11.6-25v-3.4h-3.2v3.4h3.2z m0 5v-3.4h-3.2v3.4h3.2z m-5-5v-3.4h-3.2v3.4h3.2z m0 5v-3.4h-3.2v3.4h3.2z m0 6.6v-3.4h-13.2v3.4h13.2z m-15-11.6v-3.4h-3.2v3.4h3.2z m0 5v-3.4h-3.2v3.4h3.2z m1.8-3.4v3.4h3.2v-3.4h-3.2z m0-5v3.4h3.2v-3.4h-3.2z m5 5v3.4h3.2v-3.4h-3.2z m0-5v3.4h3.2v-3.4h-3.2z m15-5c1.8 0 3.2 1.6 3.2 3.4v16.6c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-16.6c0-1.8 1.4-3.4 3.2-3.4h26.8z' })
        )
    );
};

exports.default = MdKeyboardHide;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/keyboard-hide.js
// module id = 3460
// module chunks = 168707334958949